package com.anjuros.website.redesign.sections.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the Blog page: the blog with its articles, and the breadcrumb. */
@Composable
fun blogStructuredData(): String {
    val name = LocalText(RdText.BLOG_HERO_TITLE_START) + LocalText(RdText.BLOG_HERO_TITLE_MARK)
    val posts = BlogGuides.sortedByDescending { it.published }.map { guide ->
        """{"@type":"BlogPosting","headline":${jsonString(LocalText(guide.card.title))},""" +
            """"url":"$SITE_URL${guide.card.pathToArticle}","datePublished":"${guide.published}","image":"$SITE_URL${guide.image.src}"}"""
    }.joinToString(",")
    val breadcrumb = rdBreadcrumbJsonLd(RdText.BLOG_CRUMB, RdRoute.BLOG)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"Blog","@id":"$SITE_URL${RdRoute.BLOG}#blog","url":"$SITE_URL${RdRoute.BLOG}","name":${jsonString(name)},
          "publisher":{"@id":"$SITE_URL/#business"},"blogPost":[$posts]},
         $breadcrumb
        ]}
    """.trimIndent()
}
